import './BetbookFilterButton.less';

import clsx from 'clsx';
import React, { forwardRef } from 'react';
import i18n from '../../../common/i18n';

const BetbookFilterButton = forwardRef(({ active, onClick, opened, resultsCount, value }, ref) => (
    <button
        className={clsx(
            'betbook-extended-filter-button flex items-center justify-between min-width br-radius-xs py-5 px-10 p-rel ml-10',
            { active }
        )}
        data-atid="betbook-extended-filter"
        onClick={onClick}
        ref={ref}
        value={value}
    >
        {i18n('nui.betbook.extended-filters-button')}
        {resultsCount ? <div className="ml-5">{`(${resultsCount})`}</div> : null}
        <div className="filter-button-cross-icon ml-10">
            <div className={clsx('vertical', { active, opened, closed: !opened })} />
            <div className={clsx('horizontal', { active, opened, closed: !opened })} />
            <div className="plus alt" />
        </div>
    </button>
));

export default BetbookFilterButton;
